<script lang="ts">
  // lib
  import { EventTracking } from "@shared/services/event_tracking/events";
  import {
    CartOrderEntity,
    CartOrderAlertEntity,
    DistributorEntity,
    OrderEntity,
  } from "@shared/services/event_tracking/entities";
  import { VT_802_SPIRITS_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

  // types
  import type { CartOrderType } from "@shared/types/Cart";

  // props
  export let highlightErrors: boolean;
  export let order: CartOrderType;
  export let alertText: string = "sales rep" || "account number";
  export let openConnectDistributorModal;

  // functions
  function openConnectSalesRepModal(distributor: any) {
    trackClick("cart_add_" + alertEntityName, [
      new OrderEntity({ id: order.id }),
      new DistributorEntity({ id: order.distributor.id }),
    ]);
    openConnectDistributorModal(distributor);
  }

  // data
  const { trackClick, trackMrcEvents } = EventTracking;

  $: alertEntityName = alertText == "sales rep" ? "sales_rep" : "account_number";
</script>

<div
  style="flex-wrap: nowrap;"
  class="fizz-stack-12 fizz-alert--small"
  class:fizz-alert-warning={!highlightErrors}
  class:fizz-alert-error={highlightErrors}
  use:trackMrcEvents={[
    [
      new CartOrderEntity({ distributorId: order.distributor.id, orderId: order.id }),
      new CartOrderAlertEntity({ alert_type: alertEntityName }),
    ],
  ]}
>
  <p class="fizz-text-small">
    <span class="fizz-text-strong">
      {#if alertEntityName === "account_number"}
        {#if order.distributor.id === VT_802_SPIRITS_DISTRIBUTOR_ID}
          Complete account connection:
        {:else}
          Account number required:
        {/if}
      {:else}
        Sales rep required:
      {/if}
    </span>
    {#if alertEntityName === "account_number"}
      {#if order.distributor.id === VT_802_SPIRITS_DISTRIBUTOR_ID}
        Your third class liquor license is needed to send orders.
      {:else}
        Your account number is used to connect you to this distributor.
      {/if}
    {:else}
      Your order is submitted via your sales rep.
    {/if}
  </p>
  <div class="fizz--alert-links">
    <button
      class="fizz-button fizz-button-small"
      on:click={() => openConnectSalesRepModal(order.distributor)}
    >
      {#if order.distributor.id === VT_802_SPIRITS_DISTRIBUTOR_ID}
        Connect Account
      {:else}
        Add {alertText}
      {/if}
    </button>
  </div>
</div>
